// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"125":"088aefc2","205":"75569dfb","551":"21862df2","617":"6e67b081"}[chunkId] + ".chunk.js";
};